import React from 'react';

export default function ChatGroupListComponent({ children }) {
  return <div className="chat-group-list-component">{children}</div>;
}
